<template>
  <div v-if="saida" class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">Detalhes da Saída</h4>
      <router-link to="/operacional/saidas-animais">
        <button class="btn btn-secondary btn-sm">Voltar</button>
      </router-link>
    </div>

    <div class="form-content mt-3">
      <FormSection title="Informações do Animal">
        <p><strong>Nome do Animal:</strong> {{ saida.animal_nome || 'Não informado' }}</p>
        <p><strong>Proprietário:</strong> {{ saida.proprietario_nome || 'Não informado' }}</p>
      </FormSection>

      <FormSection title="Motivo da Saída">
        <p><strong>Motivo:</strong> {{ saida.motivo || 'Não informado' }}</p>
      </FormSection>

      <FormSection title="Detalhes da Saída">
        <p><strong>Local:</strong> {{ saida.local || 'Não informado' }}</p>
        <p><strong>Estado:</strong> {{ saida.estado_nome || 'Não informado' }}</p>
        <p><strong>Município:</strong> {{ saida.municipio_nome || 'Não informado' }}</p>
        <p><strong>Responsável:</strong> {{ saida.responsavel_tipo || 'Não informado' }}</p>
        <p><strong>Nome do Responsável:</strong> {{ saida.responsavel_nome || 'Não informado' }}</p>
      </FormSection>

      <FormSection title="Períodos">
        <p><strong>Saída Prevista:</strong> {{ utils.formatarData(saida.data_saida_prevista) }}</p>
        <p><strong>Retorno Previsto:</strong> {{ utils.formatarData(saida.data_retorno_prevista) }}</p>
        <p><strong>Saída Efetiva:</strong> {{ utils.formatarData(saida.data_saida_efetiva) }} {{ utils.formatarHora(saida.hora_saida_efetiva) }}</p>
        <p><strong>Retorno Efetivo:</strong> {{ utils.formatarData(saida.data_retorno_efetiva) }} {{ utils.formatarHora(saida.hora_retorno_efetiva) }}</p>
      </FormSection>

      <FormSection title="Observações">
        <p>{{ saida.observacoes || 'Nenhuma' }}</p>
      </FormSection>

      <!-- 🔹 TABELA DE ARQUIVOS -->
      <FormSection title="Arquivos">
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead class="table-light">
              <tr>
                <th class="text-center">Tipo</th>
                <th class="text-center">Nome</th>
                <th class="text-center">Data</th>
                <th class="text-center">Arquivo</th>
                <th class="text-center">Tamanho</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="arquivos.length === 0">
                <td colspan="5" class="text-center">Nenhum arquivo anexado.</td>
              </tr>
              <tr v-for="arquivo in arquivos" :key="arquivo.id_arquivo">
                <td class="text-center">{{ arquivo.tipo || 'Não informado' }}</td>
                <td class="text-center">{{ arquivo.nome }}</td>
                <td class="text-center">{{ utils.formatarData(arquivo.data_upload) }}</td>
                <td class="text-center">
                  <a :href="getFileUrl(arquivo.caminho)" target="_blank" class="btn btn-link btn-sm text-dark">
                    <i class="bi bi-download"></i>
                  </a>
                </td>
                <td class="text-center">{{ formatarTamanho(arquivo.tamanho) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </FormSection>
    </div>
  </div>

  <div v-else>
    <LoadingSpinner />
  </div>
</template>

<script>
import axios from "@/services/axios";
import FormSection from "@/components/Layout/FormSection.vue";
import globalUtils from "@/utils/globalUtils.js";

export default {
  components: { FormSection },
  data() {
    return {
      saida: null,
      arquivos: [], // 🔹 Adicionamos essa variável para armazenar os arquivos
    };
  },

  computed: {
      utils() {
        return globalUtils;
      }
    },

  methods: {
    async carregarDetalhesSaida() {
      try {

        const response = await axios.get(`/operacional/saidas-animais/${this.$route.params.id}`);
        this.saida = response.data;
      } catch (error) {
        console.error("Erro ao carregar os detalhes da saída:", error);
      }
    },

    async carregarArquivos() {
      try {
        const response = await axios.get(`/operacional/saidas-animais/arquivos/${this.$route.params.id}`);
        this.arquivos = response.data;
      } catch (error) {
        console.error("Erro ao carregar arquivos:", error);
      }
    },

    formatarTamanho(tamanho) {
      if (!tamanho) return "0 KB";
      const kb = tamanho / 1024;
      return kb > 1024 ? (kb / 1024).toFixed(2) + " MB" : kb.toFixed(2) + " KB";
    },

    getFileUrl(caminho) {
      return `${axios.defaults.baseURL}/${caminho}`;
    },
  },
  async mounted() {
    await this.carregarDetalhesSaida();
    await this.carregarArquivos();
  },
};
</script>

<style scoped>
.card {
max-width: 90%;
margin: 0 auto;
}

.form-header {
display: flex;
justify-content: space-between;
align-items: center;
margin-bottom: 0rem;
}

.form-header h4 {
margin: 0;
font-weight: bold;
text-align: left;
}

.form-content {
margin-top: 1.5rem;
}

button.btn-sm {
padding: 6px 12px;
}

/* Ícone de download preto */
.btn-link i.bi-download {
  font-size: 1rem;  /* Ajuste o tamanho do ícone */
  color: black !important; /* Mantém preto */
}

/* Centralizar ícone na coluna */
td.text-center {
  text-align: center;
  vertical-align: middle;
}

</style>
